import React from "react";
import {Link, useLocation} from "react-router-dom";
import {LoggedInRoutes, clusterIdFromPath} from "../../LoggedInRoutes";
import SystemEntityStatus from "../loggedin/clusters/ui/SystemEntityStatus";
import ClusterHealthStatus from "../loggedin/clusters/ui/ClusterHealthStatus";

/*
 * Primary navigation: all clusters, with the pages of the current cluster expanded below it. The pages of a
 * cluster are provided by the cluster pages through the SidebarContext.
 */
export default function NavigationRail({clusters, sidebar}) {

  const location = useLocation();
  const activeClusterId = clusterIdFromPath(location.pathname);

  if (!clusters) {
    return null;
  }

  return (
      <nav className="sidebar">
        <ul className="cluster-list">
          {clusters.map((cluster) => {
            const active = cluster.uuid === activeClusterId;

            return (
                <li key={cluster.uuid} className={"cluster-item" + (active ? " active" : "")}>
                  <Link to={LoggedInRoutes.CLUSTERS.SHOW(cluster.uuid)} className="cluster-link" title={cluster.name}>
                    <SystemEntityStatus status={cluster.status} />
                    <span className="cluster-item-name">{cluster.name}</span>
                    <ClusterHealthStatus cluster={cluster} />
                  </Link>

                  {active && sidebar ? <div className="cluster-subnav">{sidebar}</div> : null}
                </li>
            )
          })}
        </ul>

        <p className="sidebar-add">
          <Link to={LoggedInRoutes.CLUSTERS.MGMT.CREATE}>
            <i className="bx bx-plus" /> Add Cluster
          </Link>
        </p>
      </nav>
  )

}
